import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';
import {TranslatedEmb} from '../../../allkey/locale/message/TranslatedEmb';

export class VisionStep extends BasicEntity {
chronoCode: string;
code: string;
dataMode: string;
description: TranslatedEmb;
label: TranslatedEmb;
level: number | null;
visionCode: string;
}

